import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Form, Input, Button, notification } from 'antd'
import { mapStateToProps, mapDispatchToProps, connect } from '../../reducers/Dispatchers'
import { request, generalErrorHandler } from '../../utils'
import { HttpMethods } from '../../utils/apiHelper'
import { getPasswordResetLink } from '../../utils/passwordResetLink'
import { getPasswordPolicyError } from '../../utils/validators'

const FormItem = Form.Item

class NormalPasswordResetForm extends React.Component {
  state = {
    confirmDirty: false,
    loading: false,
    passwordResetToken: null,
    // A single page for two cases: reset (24 h link) and activation of a brand new account (7-day
    // link of the account creation email) — only the wording differs, see getPasswordResetLink.
    isWelcome: false
  }

  componentDidMount () {
    const link = getPasswordResetLink()

    if (link === null) {
      this.props.onBack()
      return
    }

    this.setState({ passwordResetToken: link.token, isWelcome: link.isWelcome })
    // The token leaves the address bar (it stays usable until it has been consumed).
    window.history.pushState({ id: 'interneo' }, 'interneo', window.location.origin)
    request('/auth/reset-password/check/' + link.token, HttpMethods.GET, null, null, { catchError: false })
      .then((json) => {
        if (typeof json.status !== 'undefined' && json.status === 'error') {
          notification.error({ message: this.props.t('password_reset.link_expired'), placement: 'bottomRight' })
          this.props.onBack()
        }
      })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ loading: true })

        const body = {
          password: values.newPassword,
          password_confirm: values.newPasswordConfirm,
          token: this.state.passwordResetToken
        }

        request('/auth/reset-password/change', HttpMethods.POST, body, null, { catchError: false })
          .then((json) => {
            this.setState({ loading: false })
            if (json.status !== 'error') {
              notification.success({ message: this.props.t('Password update successful.'), placement: 'bottomRight' })
            } else {
              notification.error({ message: this.props.t('password_reset.link_expired'), placement: 'bottomRight' })
            }
            this.props.onBack()
          })
          .catch((error) => {
            generalErrorHandler(error)
          })
      }
    })
  }

  checkFormFields = (rule, value, callback) => {
    switch (rule.field) {
      case 'newPassword': {
        if (value && this.state.confirmDirty) this.props.form.validateFields(['newPasswordConfirm'], { force: true })

        const policyError = getPasswordPolicyError(value)

        if (policyError !== null) callback(this.props.t(policyError))
        callback()
        break
      }
      case 'newPasswordConfirm':
        if (value !== this.props.form.getFieldValue('newPassword')) callback(this.props.t('common.passwords_mismatch'))
        callback()
        break
      default:
    }
  }

  render () {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = { labelCol: { xs: { span: 24 } }, wrapperCol: { xs: { span: 24 } } }

    return (
      <Form onSubmit={this.handleSubmit}>
        {this.state.isWelcome
          ? this.props.t('password_reset.welcome_message')
          : this.props.t('password_reset.choose_password')} :
        <div className='v-spacing' />
        <div style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.45)' }}>
          {this.props.t('password_policy.rules')}
        </div>
        <div className='v-spacing' />
        <FormItem {...formItemLayout}>
          {getFieldDecorator('newPassword', { rules: [{ validator: this.checkFormFields }] })(
            <Input prefix={<FontAwesomeIcon icon='lock' />} type='password' placeholder={this.props.t('common.new_password')} />
          )}
        </FormItem>
        <FormItem {...formItemLayout}>
          {getFieldDecorator('newPasswordConfirm', { rules: [{ validator: this.checkFormFields }] })(
            <Input prefix={<FontAwesomeIcon icon='lock' />} type='password' placeholder={this.props.t('common.confirm_new_password')} />
          )}
        </FormItem>
        <FormItem {...formItemLayout}>
          <Button type='primary' htmlType='submit' className='full-width' loading={this.state.loading}>
            <FontAwesomeIcon icon='check' />&nbsp;{this.props.t('common.confirm')}
          </Button>
        </FormItem>
      </Form>
    )
  }
}

const PasswordResetForm = Form.create()(NormalPasswordResetForm)
export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetForm)
